import { Box } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./header";
import Sidebar from "./sidebar";

const MainLayout = () => {
  return (
    <Box className="flex no-scrollbar">
      <a 
        href="#main-content" 
        className="skip-link" 
        style={{ 
          position: 'absolute', 
          left: '-9999px', 
          zIndex: 999 
        }}
      >
        Skip to main content
      </a>
      
      {/* Sidebar Navigation */}
      <aside role="navigation" aria-label="Main navigation">
        <Sidebar />
      </aside>

      {/* Main Content */}
      <Box className="flex-1 min-h-screen lg:ml-[256px]">
        <Header />

        {/* Page Content */}
        <main 
          id="main-content" 
          tabIndex={-1}
          className="h-full bg-primary-blue-50 w-full p-4 md:p-6 lg:p-[30px] mt-[65px] lg:mt-[78px] overflow-auto"
          role="main"
        >
          <Outlet />
        </main>
      </Box>
    </Box>
  );
};

export default MainLayout;
